<template>
    <div>
        <files-browser v-if="browserType == 'fusion'" :enableAssetMultiSelect="true" :workspaceList="getWorkspacesList" @close="closeModal" @handleFilesBrowse="handleFilesBrowse" style="z-index:99"></files-browser>
        <div class="common-input-field" :ref='commentDetails' :class='!replyContext?"input-field-height-check-comments":"reply-threadinput-field-height-check-comments"' style="margin-top:7px;">
            <!-- this is to show annotated image before post new comment
            <div v-show="annotatedImagePathBeforeNewComment != ''" style="background: #1d1d1d;">
                <div style="width: 60px;display: inline-block;margin: 5px;">
                    <img :src="annotatedImagePathBeforeNewComment" style="width: 100%;">
                    </div>
                </div> -->    

            <attach-file v-if="openAttachments" v-bind="attachmentData" :uniqueId='attachmentUniqueId' :emptyfiles="emptyfiles"  :alreadyAttachedFiles="attachedFiles" @openPipOfAttachment="openPipOfAttachment" @attachedFilesList="attachedFilesList" :customizeStyles="customizeStyles" class="attached-files-height-fix" :abortInProgressUpload="abortUpload"></attach-file>
            
            <!-- @keydown='editMessageEnabled?updateMessage($event):sendMessageOrReply($event)' -->
            <div v-if="showMentions && !isClientUser()" ref="scrollContainer" class='mentions-wrapper'>
                <div ref="test" v-for="(uItem, index) in filteredDropdown" :key="uItem._id" v-on:click="selectUserToBeMentioned(uItem)" :class="{ focusElement: index === focus }" class="mentions-option">
                    <div v-if="Object.keys(uItem).includes('profile_image') && !['undefined',null].includes(uItem.profile_image) && uItem.profile_image" class='user-name-or-image' style="margin-inline-end: 9px;">
                        <img :src="getProxyConvertedURL(uItem.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                    </div>
                    <div v-else class="user-name-or-image user-name" :style="style(uItem.username)" style="margin-inline-end: 9px;">{{ uItem.username.split("")[0] }}
                    </div> 
                    <div style="display: flex;align-items: center;">{{uItem.username}}</div>
                </div>
            </div> 
            <textarea  
                v-model="commentText" 
                @focus="changeBckClrOfSendBtn('focus')" 
                @keyup.delete="detectBackspace($event)" 
                v-on:keypress="checkForMentions($event)" 
                @keydown="selectElementsThroughKeys($event)"
                
                v-on:blur="changeBckClrOfSendBtn('focusout')" ref='commentArea' type="text" placeholder="Add comment..." class="border rounded text-light text-area-with-border w-100"></textarea>

            <div  v-if="allowToAddComment == true" style="float:inline-start">
                <div id="DAM-attach_media_in_comments" class="nav-item dropdown show" style="inset-inline-start:2%">
                  <div v-if="isClientUser() && isEnabled('Upload')" class="icon-background-on-hover">
                       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-paperclip" viewBox="0 0 16 16">
                            <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                            <title>{{$t('Attach files')}}</title>
                        </svg>
                       <div v-if="isClientUser() && isEnabled('Upload')" style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                            <input 
                                style="height:100%;width:100%"
                                type="file"
                                id="file"
                                ref="uploadFile"
                                multiple
                                v-on:click="resetImageUploader()"
                                v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                />
                        </div>
                  </div>    
                  <a v-if="!isClientUser()" class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-paperclip" viewBox="0 0 16 16">
                        <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                        <title>{{$t('Attach files')}}</title>
                    </svg>
                  </a>
                  <div v-if="!isClientUser()" class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick()">
                        <div style="height:20px;width:20px">
                            <img :src="fusionLogo" style="width:100%;height:100%;position: relative;inset-inline-end :4px;">
                        </div>
                      <span>{{$t('from fusion')}}</span>
                    </a>
                    <a v-if="isEnabled('Upload')" class="dropdown-item p-2" style="position:relative;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="position: relative;inset-inline-end :4px;" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                        <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                       </svg>
                      <span>{{$t('from your computer')}}</span>
                      <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                            <input 
                                style="height:100%;width:100%"
                                type="file"
                                id="file"
                                ref="uploadFile"
                                multiple
                                v-on:click="resetImageUploader()"
                                v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                />
                        </div></a>
                  </div>
                </div>
                
            </div>

            <button class="btn btn-outline-primary m-2" v-if="showAddCommentWithMarkinMarkoutBtn()" :disabled="String(commentText).trim() === ''" @click="sendMarkinMarkoutCommentPost()" style="float:inline-end">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#eee" class="bi bi-send-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"/>
                </svg>
            </button>
            
            <div style="float:inline-end">
                <button v-show="isButtonRequired('updateComment')" @click.stop.prevent="updateComment()" class="btn btn-primary btn-outline-primary button-styles" style="background:transparent;line-height: initial;margin-inline-end:10px;">
                {{$t('Save')}}
                </button>
                <button v-show="isButtonRequired('cancelUpdateComment')" @click.stop.prevent="cancelUpdateComment()" class="btn btn-primary button-styles" style="background:transparent;border-color:#5a5a5a;line-height: initial;">
                {{$t('Cancel')}}
                </button>
            </div> 

            <div v-if="allowToAddComment == true" style="float:inline-end">
                <button class="btn btn-primary button-styles" :class="replyContext == true?'replay-comment-btn':'main-comment-btn'"  @click="sendComment()" style="background:#5a5a5a;border-color:#5a5a5a">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#eee" class="bi bi-send-fill" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"/>
                    </svg>
                </button>
            </div> 
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions} from 'vuex';
import AttachFile from "../core/Attachments.vue";
import fileBrowseModel from "../files/filesBrowse.vue";
import Constants from "../../components.constants"
import Utils from "../../components.utils.js";

export default {
   name:'Comments',
   props:['commentDetails','enableMinimalData', 'allowToAddComment', "replyContext", "idOfParentComment", "showAddCommentWithMarkinMarkout", "buttonRequiredList", "commentDataToEdit","attachmentContext", "annotatedImagePathBeforeNewComment", "projectUsersList"],
   data(){
       return {
           commentText:"",
           selectedFilesFromAttachments:null,
           attachedFilesArr:[],
           attachmentUniqueId:null,
           openAttachments:false,
           emptyfiles:false,
           browserType:"",
           fusionLogo:Utils.getLogo(),
           attachedFiles:[],
           chatBrowseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
           customizeStyles:{
               "background": "#22272b",
               "border": "1px solid  #434343"
           },
           abortUpload:false,

           showMentions:false,
           keypressedForMention:'',
            // usersList:[],
            focus: null,
       };
   },
   mounted(){
   },
   components:{
       'attach-file':AttachFile,
       "files-browser":fileBrowseModel
   },
   computed:{
        attachmentData(){
            return {selectedFilesFromAttachBrowse:this.selectedFilesFromAttachments}
        },
        getWorkspacesList(){
            return this.chatBrowseWorkspaceList;
        },
        filteredDropdown() {
            let assignedUsersList = [];
                if(this.projectUsersList)assignedUsersList = this.projectUsersList;
            if(this.keypressedForMention.substr(1) != null){
                if (!assignedUsersList.length) {
                    return [];
                }
                    return assignedUsersList.filter((item) => {
                    const username = item.username.toLowerCase();
                    const searchTerm = this.keypressedForMention.substr(1).toLowerCase();
                    return username.includes(searchTerm);
                });
            }else{
                return assignedUsersList;
            }
        },
        ...mapGetters("users", ["getLoggedInUserPrivilege"])
    },
   watch :{
        commentText(newVal){
            this.$emit("postComment",newVal); 
        },

        commentDataToEdit(newVal){
            if(newVal != undefined && newVal != null){
                this.commentText = newVal;
            }
        },
        attachmentContext(newVal){
            if(newVal != undefined && newVal != null){
                this.attachmentUniqueId = this.attachmentContext;
            }
        }
   },

   methods:{
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
       closeModal(){
            this.attachedFiles = [];
            this.browserType = '';
        },
       resetImageUploader(){
            this.$refs.uploadFile.value = '';
       },
       getSelectedFileDetailsFromBrowse(){
        this.selectedFilesFromAttachments = this.$refs.uploadFile.files;
        this.browserType = "";
        this.openAttachments = true;
       },
       handleFilesBrowse(selectedFiles){
            this.attachedFiles = selectedFiles;
            this.openAttachments = true;
            this.browserType = '';
        },
       openFileBrowseOnClick(){
            this.browserType = "fusion";
        },
       changeBckClrOfSendBtn(action){
            if(action == "focus"){
                if(this.replyContext == true){
                    // if(document.getElementsByClassName("replay-comment-btn")) document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #007bff; border-color:#007bff;"); 
                    document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }else{
                    document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #007bff; border-color:#007bff;"); 
                    // if(document.getElementsByClassName("replay-comment-btn")) document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }
            }else{
                 if(this.replyContext == true){
                    // if(document.getElementsByClassName("replay-comment-btn")) document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }else{
                    document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }          
            }    
       },

        isButtonRequired(name){
            if(!this.buttonRequiredList) return false;
            if(this.buttonRequiredList && Array.isArray(this.buttonRequiredList) && this.buttonRequiredList.length === 0) return false;
            if(this.buttonRequiredList.indexOf(name) > -1) return true;
            return true;
        },
        attachedFilesList(attcahedFilesArray,alreadyAttachedFiles){
            this.$refs.commentArea.focus();
            this.attachedFilesArr = [];
            if(alreadyAttachedFiles != undefined && alreadyAttachedFiles.length){
                for(let j = 0; j< alreadyAttachedFiles.length; j++){
                    this.attachedFilesArr.push(alreadyAttachedFiles[j].file_uid);
                }
            }
            if(attcahedFilesArray != undefined && attcahedFilesArray.length){
                for(let i=0; i<attcahedFilesArray.length; i++){
                    this.attachedFilesArr.push(attcahedFilesArray[i].fileUID);
                }
            }
        },
       sendComment(){
           if(document.getElementsByClassName("upload-unInitialized") && document.getElementsByClassName("upload-unInitialized").length){
                if (confirm(`Upload not initialized, do you want to continue?`)) {
                    //do nothing
                    // this.abortUpload = true;
                    this.emptyfiles = true;
                }else{
                    return false;
                }
           }
           if(document.getElementsByClassName("upload-in-progress") && document.getElementsByClassName("upload-in-progress").length){
                if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                    return false;
                }else{
                    //do nothing
                    this.emptyfiles = true;
                    // this.abortUpload = true;
                }
           }
           if(this.commentText == "" && !this.attachedFilesArr.length){
                this.$toast.error("Empty comment");
                return false;   
           }
           this.$emit("postComment",this.commentText)
            if(this.replyContext == true){
                let replyCommentObj = {};
                replyCommentObj["comment"] = this.commentText;
                replyCommentObj["user_id"] = this.getLoggedInUserId();
                replyCommentObj["status"] = "Open"
                replyCommentObj["pid"] = this.idOfParentComment;
                replyCommentObj["attachments"] = this.attachedFilesArr;
                this.$emit("replyPostData", replyCommentObj);
            }else{

                let parentCommentObj = {};
                parentCommentObj["pid"] = 0;
                parentCommentObj["comment"] = this.commentText;
                parentCommentObj["user_id"] = this.getLoggedInUserId();
                parentCommentObj["attachments"] = this.attachedFilesArr;
                parentCommentObj["status"] = "Open"

                this.$emit("commentPostData", parentCommentObj);
            }    
            this.commentText = "";
            this.emptyfiles = true;
            this.openAttachments = false;
            this.attachedFilesArr = [];
            this.attachedFiles = [];
            this.browserType= '';
            this.selectedFilesFromAttachments = '';
        },

        updateComment(){
            if(this.commentText == ""){
               this.$toast.error("Empty comment");
               return false;
            }
        //    this.$emit("postComment",this.commentText)
            if(this.replyContext == true){
                let replyCommentObj = {};
                replyCommentObj["comment"] = this.commentText;
                replyCommentObj["user_id"] = this.getLoggedInUserId();
                replyCommentObj["status"] = "Open"
                // replyCommentObj["pid"] = this.idOfParentComment;
                replyCommentObj["pid"] = this.commentDetails.pid;
                replyCommentObj["attachments"] = this.attachedFilesArr;
                this.$emit("replyPostData", replyCommentObj);
            }else{
                let parentCommentObj = {};
                parentCommentObj["pid"] = 0;
                parentCommentObj["comment"] = this.commentText;
                parentCommentObj["user_id"] = this.getLoggedInUserId();
                parentCommentObj["attachments"] = this.attachedFilesArr;
                parentCommentObj["status"] = "Open"

                this.$emit("commentPostData", parentCommentObj);
            }    
            this.commentText = "";
            this.emptyfiles = true;
            this.openAttachments = false;
            this.attachedFilesArr = [];
            this.attachedFiles = [];
            this.browserType= '';
            this.selectedFilesFromAttachments = '';
        },

        cancelUpdateComment(){
            this.$emit("closeEditingComment", false);
            this.commentText = this.commentDetails.comment;
            this.showMentions = false;
        },

        sendMarkinMarkoutCommentPost(){
            this.$emit('add-markin-markout',this.commentText);
            this.commentText = "";
        },

        showAddCommentWithMarkinMarkoutBtn(){
            if(!this.showAddCommentWithMarkinMarkout || this.showAddCommentWithMarkinMarkout == false) return false;
            return true;
        },

        isEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },

        openPipOfAttachment(fileInfo){
            this.$emit("openPipOfAttachment",fileInfo)
        },

        isClientUser(){
            if(this.getLoggedInUserType() == 'Client'){
                return true;
            }else{
                return false;
            }
        },

        detectBackspace(){
            let lastWord = this.commentText.split(" ");
            let mentionCharacterCheck = lastWord[lastWord.length - 1].startsWith('@');
            if(mentionCharacterCheck){
                this.keypressedForMention = lastWord[lastWord.length - 1];
            }else{
                this.keypressedForMention = '';
                this.showMentions = false;
            }
        },

        checkForMentions(e){
            if(!this.isClientUser()){
                let temp = /[ `!#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
                if(temp.test(e.key) || e.code == 'Space'){
                    this.showMentions = false;
                    this.keypressedForMention = '';
                    return;
                }
                
                if(e.key == '@'){
                    if(this.keypressedForMention.startsWith('@')){
                        this.showMentions = false;
                    }else{
                        this.showMentions = true;
                        this.keypressedForMention = e.key;
                    }
                        this.showMentions = true;
                }
                if(this.keypressedForMention.startsWith('@')){
                    if(e.key != '@'){
                        this.keypressedForMention = this.keypressedForMention.concat(e.key);
                    }
                }else{
                    this.keypressedForMention = '';
                    this.showMentions = false;
                }
            }    
        },

        selectElementsThroughKeys: function(event) {
            switch (event.keyCode) {
                case 38:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus > 0) {
                    this.focus--;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 40:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus < this.projectUsersList.length - 1) {
                    this.focus++;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 13:
                    if(this.showMentions){
                        this.stop = true;
                        this.selectUserToBeMentioned(this.filteredDropdown[this.focus]);
                        event.preventDefault();
                    }
                break;
            }
            
        },

        // usersListFn() {
        //     this.getAllUsersFromServer().then((data) => {
        //         this.usersList = data['users'];
        //     })                  
        // },

        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },

        selectUserToBeMentioned(userData){
            let curPos = 0;
            if(this.$refs["commentArea"]){
                curPos = this.$refs["commentArea"].selectionStart;
            }else{
                curPos = this.$refs["replyMessageArea"].selectionStart;
            }
            let text_to_replace = userData.username + " ";
            if(this.keypressedForMention.length == 1 && this.keypressedForMention == '@'){
                this.commentText = this.commentText.slice(0, curPos) + text_to_replace + this.commentText.slice(curPos);
            }else{
                this.commentText = this.commentText.slice(0, curPos - this.keypressedForMention.length) + '@'+text_to_replace + this.commentText.slice(curPos);
            }
            this.keypressedForMention = '';
            this.showMentions = false;
            if(this.$refs["commentArea"]){
                this.$refs.commentArea.focus();
            }else{
                this.$refs["replyMessageArea"].focus();
            }
        },

        fixScrolling(){
            const liH = this.$refs.test[this.focus].clientHeight;
            this.$refs.scrollContainer.scrollTop = liH * this.focus;
        },

        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId", "getLoggedInUserType"]),
        // ...mapActions('reviewData',['getChatUsersFromServer']),
        ...mapActions("users", ["getAllUsersFromServer"]),
        
    },

    created(){
        //    alert(this.selectedFileUID);
        if(this.commentDataToEdit != undefined && this.commentDataToEdit != undefined){
            this.commentText = this.commentDataToEdit;
        }
        this.attachmentUniqueId = this.attachmentContext;
        // this.usersListFn();
    }
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $panel-heading-font-size:18px;

.attached-files-height-fix{
    max-height:300px;
    overflow:auto;
    padding:4px;
}

.text-area-with-border{
    max-height:200px;
    min-height: 80px;
    padding: 4px; 
    border: $border-color !important
}
.remove-border{
    max-height:200px;
    min-height: 80px;
    padding: 4px; 
    border: none !important;
    background:transparent;
} 
.remove-border:focus{
    outline: none !important;
    box-shadow: none;
}
.common-input-field{
    display: inline-block;
    width: 98%;
    margin-inline-start:7px;
    justify-content: space-between;
    display: inline-block;
    padding: 9px;
    border-radius: 4px;
    background: $primary-background !important;
    border: $secondary-border-color !important;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-fields,.mx-datepicker, textarea,.multiselect{
    border-radius: 3px !important;
    border:$border-color!important;
    height: 38px;
    background: $primary-background;
}

textarea:focus{
  outline: none;
  bottom: 0px;
  inset-inline-start:0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.button-styles{
  height: 30px;
  width: auto;
  font-size: 14px;
  svg{
      position: relative;
      bottom: 3px;
  }
}

.icon-background-on-hover:hover{
  background: #fdfeff54 !important;
  padding: 4px;
  height: 28px;
  width: 28px;
  border-radius: 4px !important;
  margin-inline-end:5px;
}

.icon-background-on-hover{
  background: #d1d2d31a;
  padding: 4px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  margin-inline-end:5px;
}

.mentions-wrapper{
    position: relative;
    border: $border-color;
    background: $secondary-background-color;
    max-height: 200px;
    min-width:200px;
    overflow: auto;
    z-index: 9;
    border-radius: 5px;
    .mentions-option{
        text-align: start;
        padding: 5px;
        display:flex;
        color:#eee !important;
    }
    .mentions-option:hover{
        background: #333;
    }
}

.focusElement{
    background: #333;
}

/* width */
    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
</style>